import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
  fetchChatAvailability,
  fetchChatOpeningHours
} from '../thunks/chat-window';

interface ChatWindowState {
  numberOfUnreadMessages: number;
  isVisible: boolean;
  showTab: boolean;
  scrollPosition?: number;
  availability?: boolean;
  queueTooLong?: boolean;
  isWithinOpeningHours: boolean;
  isClosedWithinOpeningHours: boolean;
}

const initialState: ChatWindowState = {
  numberOfUnreadMessages: 0,
  isVisible: false,
  showTab: true,
  isWithinOpeningHours: false,
  isClosedWithinOpeningHours: false
};

const chatWindow = createSlice({
  name: 'chatWindow',
  initialState,
  reducers: {
    resetNumberOfUnreadMessages(state) {
      state.numberOfUnreadMessages = 0;
    },
    updateNumberOfUnreadMessages(state, action: PayloadAction<number>) {
      state.numberOfUnreadMessages = action.payload;
    },
    showChatActivations(state) {
      state.showTab = true;
    },
    hideChatActivations(state) {
      if (!state.isVisible) {
        state.showTab = false;
      }
    },
    toggleChatWindowVisible(
      state,
      action: PayloadAction<{ isVisible: boolean; scrollPosition?: number }>
    ) {
      state.isVisible = action.payload.isVisible;
      state.scrollPosition = action.payload.scrollPosition;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchChatAvailability.fulfilled, (state, action) => {
      state.availability = action.payload.available;
      state.queueTooLong = action.payload.queueTooLong;
    });

    builder.addCase(fetchChatOpeningHours.fulfilled, (state, action) => {
      state.isWithinOpeningHours = action.payload.isWithinOpeningHours;
      state.isClosedWithinOpeningHours =
        action.payload.isClosedWithinOpeningHours;
    });
  }
});

export const chatWindowActions = chatWindow.actions;

export default chatWindow.reducer;
